import React, { useCallback } from "react";
import { FormWidgetProps } from ".";
import { FormFieldConfiguration } from "../crud/form";
import styled from "styled-components";

// Component
import SmartSelector from "../../witadmin/CRUD/Common/SmartSelector";
import { SectionLabel } from "./SectionLabel";
import { SectionDescription } from "./SectionDescription";

// Styleds
const Container = styled.span`
  input {
    width: 0;
  }
  .form-group {
    margin-bottom: 0px;
  }
`;

export interface SmartSelectorItem {
  ticker: string;
  name: string;
  filters: any;
}

interface SmartSelectorConfig {
  filterNames: string[];
}

type SmartSelectorProps<T> = FormWidgetProps<T> & {
  config?: SmartSelectorConfig;
  allowedValues?: SmartSelectorItem[];
};
interface EventPayload {
  value: string[];
  index?: string;
  field: string;
}

function SmartSelectorWidget<T extends string[]>({
  schema,
  idSchema,
  formData,
  config,
  allowedValues,
  onChange,
}: SmartSelectorProps<T>) {
  const handleOnChange = useCallback(
    (payload: EventPayload) => {
      if (!payload || !Array.isArray(payload.value)) {
        return onChange([]);
      }
      if (
        !formData ||
        payload.value.find(v => !formData.includes(v)) ||
        formData.find(d => !payload.value.includes(d))
      ) {
        const values =
          payload.value &&
          payload.value.filter(value => allowedValues?.some(a => a.ticker === value));
        return onChange(values);
      }
    },
    [formData, onChange, allowedValues]
  );

  return (
    <div id={idSchema.$id}>
      <SectionLabel>{schema.title}</SectionLabel>
      <SectionDescription>{schema.description}</SectionDescription>
      <Container className="witadmin-bs3 witadmin-bs3-parent">
        <SmartSelector
          onChange={handleOnChange}
          field={{
            fieldName: idSchema.$id,
            defaultValue: [],
            filterNames: config?.filterNames,
            options: allowedValues,
            staticFilters: {},
          }}
          value={formData}
        />
      </Container>
    </div>
  );
}

export function smartSelectorFieldConfig<T extends string[]>(
  allowedValues: SmartSelectorItem[],
  config: SmartSelectorConfig
): FormFieldConfiguration<T> {
  return {
    fieldWidget: (props: FormWidgetProps<T>) => (
      <SmartSelectorWidget {...{ ...props, config, allowedValues }} />
    ),
  };
}
